<template>
    <div class="relative">
        <AppButton
            @click="toggleDropdownVisible"
            :aria-expanded="isDropdownVisible"
            :class="{
                '!bg-gray-tier-6': isDropdownVisible,
            }"
            icon="addition-sign"
            icon-size="large"
            text="Add to Project"
        >
            
        </AppButton>
        <div
            v-if="isDropdownVisible"
            v-click-outside="closeDropdown"
            class="
                absolute 
                right-0
                rounded-md 
                top-full  
                translate-x-[58px] 
                translate-y-[15px] 
                w-[calc(var(--app-detail-aside-width)_-_4rem)] 
                z-10
                overflow-y-auto max-h-[400px]
                dark:bg-v2-gray-50
                bg-v2-white
                border border-gray-225 dark:border-gray-850 shadow-black/20 shadow-xl
            "
        >
            <ProjectListSkeleton v-if="isLoadingProjects" class="p-5" />
            <ul v-else-if="projects.length" class="space-y-2 p-5">
                <ProjectOption v-for="project in projects" :project="project" />
            </ul>
            <Link :href="route('web.account.projects.index')" v-else class="block text-center rounded border border-dashed border-v2-gray-70 hover:border-gray-400 duration-150 p-5">
                <BaseSvg name="icon-projects-outline-thick" class="w-6 h-6" />
                <div class="font-medium text-sm">No Projects</div>
                <div class="text-xs type-secondary">Click here to get started</div>
            </Link>
        </div>
    </div>
</template>

<script setup>
import {inject, onMounted, ref, watch} from "vue";
import {BaseSvg, ProjectListSkeleton, ProjectOption, AppButton} from "@/Components";
import {Link} from "@inertiajs/vue3";
import {useProjects} from "@/Composables";

const route = inject("route");
const isDropdownVisible = ref(false);

const { loadProjects, isLoadingProjects, projects } = useProjects();

function toggleDropdownVisible() {
    isDropdownVisible.value = !isDropdownVisible.value;
}

function closeDropdown () {
    isDropdownVisible.value = false;
}

onMounted(() => {
    loadProjects();
})
</script>
